import { AdditionalPayItem } from './additional-pay-item.model';

export class VacationPayItem extends AdditionalPayItem {
    protected static _resource = 'payroll/vacationPayItems';
}
